import { PostEditorReducerFunction, PostEditorSetPostStatusAction } from '../PostEditorActions';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';

export const setPostStatusReducer: PostEditorReducerFunction<PostEditorSetPostStatusAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { customizeIndex, postGroupIndex, postStatus, customizeType } = payload;
  let customization: false | 'customizeSchedulePerProfile' | 'customizeContentPerProfile';
  switch (customizeType) {
    case 'content':
      customization = 'customizeContentPerProfile';
      break;
    case 'schedule':
      customization = 'customizeSchedulePerProfile';
      break;
    default:
      customization = false;
  }
  const isCustomizing =
    customization && state.postGroups[postGroupIndex][customization] && customizeIndex !== undefined;
  const result = updateImmutable(state, {
    postGroups: {
      [postGroupIndex]: {
        posts: currentPosts =>
          isCustomizing
            ? updateImmutable(currentPosts, {
                [customizeIndex]: {
                  postStatus: {
                    $set: postStatus
                  }
                }
              })
            : currentPosts,
        groupPostAttributes: {
          postStatus: {
            $apply: currentStatus => (customization ? currentStatus : postStatus)
          }
        }
      }
    }
  });
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning);
};
